/** @jsx jsx */
import { ReactNode } from 'react';

import { HideFooter } from '@zapier/common-components';
import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import useDocumentTitle from 'app/developer-v3/hooks/useDocumentTitle';

const Styles = {
  developerCss: css`
    background-color: ${Colors.PrimeWhite};
    display: flex;
    flex: 1;
    flex-direction: column;
    height: calc(100vh - 69px);
    overflow: auto;
    position: relative;
    z-index: 0;

    .sidebar-accordion__title {
      letter-spacing: initial;
    }

    table {
      width: 100%;
    }

    & .CodeMirror,
    & .formatic .fm-field input,
    & .formatic .fm-field textarea.fm-string,
    & .formatic .fm-field .fm-singlelinestring,
    & .formatic .fm-field .fm-pretty-select-value span.select-arrow,
    & .formatic .fm-field div.pretty-text-box {
      background-color: inherit;
      :hover {
        background-color: inherit;
      }
    },
  `,
};

type Props = {
  children: ReactNode;
};

const Developer = (props: Props) => {
  useDocumentTitle('Platform UI');
  return (
    <HideFooter>
      <div css={Styles.developerCss} id="main">
        {props.children}
      </div>
    </HideFooter>
  );
};

export default Developer;
